import { useNavigate } from "react-router-dom";
import { useContext } from "react";
import CircularProgress from "@mui/material/CircularProgress";
import NotificationForm from "../../shared/notification-form";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import style from "./style";

const NotificationWizardView = ({
  values,
  currentSection,
  isCreating,
  isParsingPhoneNumber,
  isPhoneNumberParsed,
  isSectionComplete = () => {},
  handleFormSubmit = () => {},
  notificationOnChange = () => {},
  onParsingPhoneNumber = () => {},
  onPhoneNumParsedSuccess = () => {},
  onClickB1 = () => {},
  onClickB2 = () => {},
  countries = [],
  teams = [],
  sites = [],
  users = [],
  loadedSites = false,
  loadedUsers = false,
  loadedCountries = false,
  loadedTeams = false,
  hasValidationError = () => {},
  validationError = false,
  loadedExtension = false,
  onNewTeamCreated={onNewTeamCreated},
  isTriggerTypeVoicemail=false
}) => {
  const navigation = useNavigate();
  return (
    <>
      <Box sx={style.pageHeadingWrapper}>
        <Typography sx={style.pageHeading} variant="h5">
          New Notification
        </Typography>
        <Typography sx={style.pageHeadingCaption} variant="caption">
          Here you can create a new notification.
        </Typography>
        <span style={style.pageHeadingMarker}></span>
      </Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
        }}
      >
        <Box
          sx={{
            ...style.stepper,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            paddingBottom: "8px",
            paddingLeft: "4px",
          }}
        >
          <Box
            sx={
              currentSection === 0
                ? {
                    ...style.step,
                    ...style.activeStep,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                  }
                : currentSection !== 0 && isSectionComplete(0)
                ? {
                    ...style.step,
                    ...style.successStep,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                  }
                : {
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "grey.600",
                  }
            }
          >
            <img
              alt=""
              src={
                currentSection === 0
                  ? "/assets/edit.svg"
                  : isSectionComplete(0)
                  ? "/assets/edit-green.svg"
                  : "/assets/edit-default.svg"
              }
            />
            <Typography sx={{ marginTop: 1 }} variant="caption">
              Name
            </Typography>
          </Box>
          <Box
            // className={clsx({
            //   [style.activeStep]: currentSection === 1,
            //   [style.successStep]: currentSection !== 1 && isSectionComplete(1),
            // })}
            sx={
              currentSection === 1
                ? {
                    ...style.step,
                    ...style.activeStep,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                  }
                : currentSection !== 1 && isSectionComplete(1)
                ? {
                    ...style.step,
                    ...style.successStep,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                  }
                : {
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "grey.600",
                  }
            }
          >
            <img
              alt=""
              src={
                currentSection === 1
                  ? "/assets/phone.svg"
                  : isSectionComplete(1)
                  ? "/assets/phone-green.svg"
                  : "/assets/phone-default.svg"
              }
            />
            <Typography sx={{ marginTop: 1 }} variant="caption">
              Phone Number
            </Typography>
          </Box>
          <Box
            // className={clsx({
            //   [style.activeStep]: currentSection === 2,
            //   [style.successStep]: currentSection !== 2 && isSectionComplete(2),
            // })}
            sx={
              currentSection === 2
                ? {
                    ...style.step,
                    ...style.activeStep,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                  }
                : currentSection !== 2 && isSectionComplete(2)
                ? {
                    ...style.step,
                    ...style.successStep,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                  }
                : {
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "grey.600",
                  }
            }
          >
            <img
              alt=""
              src={
                currentSection === 2
                  ? "/assets/calldirection.svg"
                  : isSectionComplete(2)
                  ? "/assets/calldirection-green.svg"
                  : "/assets/calldirection-default.svg"
              }
            />
            <Typography sx={{ marginTop: 1 }} variant="caption">
              Direction
            </Typography>
          </Box>
          {!isTriggerTypeVoicemail && (
             <Box
             // className={clsx(
             //   "d-flex flex-column f-align-center f-justify-center",
             //   style.step,
             //   {
             //     [style.activeStep]: currentSection === 3,
             //     [style.successStep]:
             //       currentSection !== 3 && isSectionComplete(3),
             //   }
             // )}
             sx={
               currentSection === 3
                 ? {
                     ...style.step,
                     ...style.activeStep,
                     display: "flex",
                     flexDirection: "column",
                     alignItems: "center",
                     justifyContent: "center",
                   }
                 : currentSection !== 3 && isSectionComplete(3)
                 ? {
                     ...style.step,
                     ...style.successStep,
                     display: "flex",
                     flexDirection: "column",
                     alignItems: "center",
                     justifyContent: "center",
                   }
                 : {
                     display: "flex",
                     flexDirection: "column",
                     alignItems: "center",
                     justifyContent: "center",
                     color: "grey.600",
                   }
             }
           >
             <img
               alt=""
               src={
                 currentSection === 3
                   ? "/assets/trigger.svg"
                   : isSectionComplete(3)
                   ? "/assets/trigger-green.svg"
                   : "/assets/trigger-default.svg"
               }
             />
             <Typography sx={{ marginTop: 1 }} variant="caption">
               Trigger
             </Typography>
           </Box>
          )}
          <Box
            // className={clsx({
            //   [style.activeStep]: currentSection === 4,
            //   [style.successStep]: currentSection !== 4 && isSectionComplete(4),
            // })}
            sx={
              currentSection === 4
                ? {
                    ...style.step,
                    ...style.activeStep,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                  }
                : currentSection !== 4 && isSectionComplete(4)
                ? {
                    ...style.step,
                    ...style.successStep,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                  }
                : {
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "grey.600",
                  }
            }
          >
            <img
              alt=""
              src={
                currentSection === 4
                  ? "/assets/send.svg"
                  : isSectionComplete(4)
                  ? "/assets/send-green.svg"
                  : "/assets/send-default.svg"
              }
            />
            <Typography sx={{ marginTop: 1 }} variant="caption">
              Delivery
            </Typography>
          </Box>
          <Box
            // className={clsx({
            //   [style.activeStep]: currentSection === 5,
            //   [style.successStep]: currentSection !== 5 && isSectionComplete(5),
            // })}
            sx={
              currentSection === 5
                ? {
                    ...style.step,
                    ...style.activeStep,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                  }
                : currentSection !== 5 && isSectionComplete(5)
                ? {
                    ...style.step,
                    ...style.successStep,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                  }
                : {
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "grey.600",
                  }
            }
          >
            <img
              alt=""
              src={
                currentSection === 5
                  ? "/assets/review.svg"
                  : isSectionComplete(5)
                  ? "/assets/review-green.svg"
                  : "/assets/review-default.svg"
              }
            />
            <Typography sx={{ marginTop: 1 }} variant="caption">
              Review
            </Typography>
          </Box>
        </Box>
        <Box>
          {currentSection === 5 && (
            <Typography sx={style.reviewHeader} variant="body2">
              Please review your new notification
            </Typography>
          )}
          <NotificationForm
            countries={countries}
            teams={teams}
            sites={sites}
            loadedSites={loadedSites}
            loadedUsers={loadedUsers}
            loadedCountries={loadedCountries}
            loadedTeams={loadedTeams}
            users={users}
            currentSection={currentSection}
            onChange={notificationOnChange}
            showAll={currentSection === 5}
            onParsingPhoneNumber={onParsingPhoneNumber}
            onPhoneNumParsedSuccess={onPhoneNumParsedSuccess}
            hasValidationError={hasValidationError}
            loadedExtension={loadedExtension}
            onNewTeamCreated={onNewTeamCreated}
          />
        </Box>
        <Box
          sx={{
            ...style.actions,
            display: "flex",
            justifyContent: "end",
            marginBottom: 4,
            marginTop: "32px",
          }}
        >
          <Button
            disabled={isParsingPhoneNumber}
            sx={{ ...style.greyAction, marginRight: "20px" }}
            onClick={() => navigation("/notifications")}
            variant="outlined"
          >
            Cancel
          </Button>
          {currentSection > 0 && (
            <Button
              disabled={isParsingPhoneNumber}
              sx={{ ...style.greyAction, marginRight: "20px" }}
              variant="outlined"
              onClick={onClickB1}
            >
              Back
            </Button>
          )}
          {currentSection < 5 && (
            <Button
              sx={{ marginRight: "2px" }}
              disabled={
                !isSectionComplete(currentSection) ||
                isParsingPhoneNumber ||
                validationError
              }
              onClick={onClickB2}
              variant="contained"
            >
              {isParsingPhoneNumber ? <CircularProgress size={18} /> : "Next"}
            </Button>
          )}
          {currentSection === 5 && (
            <Button
              sx={{ marginRight: "4px" }}
              disabled={
                isParsingPhoneNumber || isCreating || !isSectionComplete()
              }
              variant="contained"
              // color={isCreating ? "default" : "primary"}
              onClick={handleFormSubmit}
            >
              {isCreating || isParsingPhoneNumber ? (
                <CircularProgress size={18} />
              ) : (
                "Create"
              )}
            </Button>
          )}
        </Box>
      </Box>
    </>
  );
};

export default NotificationWizardView;
